"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _auth = require("../../redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _selectors = require("../selectors");

var _LinkEpicAccountBox = require("../components/LinkEpicAccountBox");

var _LinkEpicAccountBox2 = _interopRequireDefault(_LinkEpicAccountBox);

var _EpicSubscriptionLogin = require("../components/EpicSubscriptionLogin");

var _EpicSubscriptionLogin2 = _interopRequireDefault(_EpicSubscriptionLogin);

var _MigrationBoxFooter = require("../components/MigrationBoxFooter");

var _MigrationBoxFooter2 = _interopRequireDefault(_MigrationBoxFooter);

var _LinkEpicAccount = require("./LinkEpicAccount.scss");

var _LinkEpicAccount2 = _interopRequireDefault(_LinkEpicAccount);

var _components = require("components");

var _LoginBox = require("../components/LoginBox");

var _LoginBox2 = _interopRequireDefault(_LoginBox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkEpicAccount = function (_React$Component) {
  (0, _inherits3.default)(LinkEpicAccount, _React$Component);

  function LinkEpicAccount(props) {
    (0, _classCallCheck3.default)(this, LinkEpicAccount);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LinkEpicAccount.__proto__ || (0, _getPrototypeOf2.default)(LinkEpicAccount)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleLogin = _this.handleLogin.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LinkEpicAccount, [{
    key: "handleSubmit",
    value: function handleSubmit(values) {
      var _props = this.props,
          epicLinkAccounts = _props.epicLinkAccounts,
          router = _props.router;
      var location = router.location;
      var query = location.query,
          pathname = location.pathname,
          returnTo = location.query.returnTo;


      return epicLinkAccounts(values).then(function () {
        if (pathname === returnTo) {
          router.replace("/");
        } else {
          if (query && query.returnTo) {
            router.replace(query.returnTo);
          } else {
            router.replace("/");
          }
        }
      });
    }
  }, {
    key: "handleLogin",
    value: function handleLogin(_ref) {
      var email = _ref.quixelEmail,
          password = _ref.password;
      var _props2 = this.props,
          verifyLogin = _props2.verifyLogin,
          router = _props2.router;


      return verifyLogin({ email: email, password: password });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          quixelEmail = _props3.quixelEmail,
          epicLinkEmail = _props3.epicLinkEmail,
          router = _props3.router,
          epicToken = _props3.epicToken,
          loggedIn = _props3.loggedIn;
      var location = router.location;
      var state = location.state;

      var modal = state ? state.modal : false;

      var initialValues = void 0;

      if (quixelEmail && quixelEmail === epicLinkEmail) {
        initialValues = { quixelEmail: epicLinkEmail };
      } else {
        initialValues = { quixelEmail: quixelEmail, epicLinkEmail: epicLinkEmail };
      }

      return _react2.default.createElement(
        "div",
        { className: _LinkEpicAccount2.default.page },
        !modal ? _react2.default.createElement(_components.SiteHeaderGap, null) : null,
        _react2.default.createElement(
          "div",
          { className: _LinkEpicAccount2.default.wrap },
          !epicToken ? _react2.default.createElement(
            _components.Popup,
            null,
            _react2.default.createElement(
              _components.Popup.Header,
              null,
              "Sign in"
            ),
            _react2.default.createElement(
              _components.Popup.Content,
              null,
              loggedIn ? _react2.default.createElement(
                "div",
                { className: _LinkEpicAccount2.default.cntwrap },
                _react2.default.createElement(_EpicSubscriptionLogin2.default, null)
              ) : _react2.default.createElement(_LoginBox2.default, { onSubmit: this.handleLogin })
            ),
            _react2.default.createElement(_MigrationBoxFooter2.default, null)
          ) : _react2.default.createElement(_LinkEpicAccountBox2.default, {
            initialValues: initialValues,
            onSubmit: this.handleSubmit
          })
        )
      );
    }
  }]);
  return LinkEpicAccount;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    quixelEmail: (0, _selectors.getQuixelEmail)(state),
    epicLinkEmail: (0, _selectors.getEpicLinkEmail)(state),
    epicToken: (0, _selectors.getEpicToken)(state),
    loggedIn: state.auth.loggedIn
  };
}, {
  epicLinkAccounts: authActions.epicLinkAccounts,
  verifyLogin: authActions.verifyLogin
})(LinkEpicAccount);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/pages/LinkEpicAccount.jsx
// module id = 2944
// module chunks = 0